<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <b-field horizontal :label="$t('attributes.name')">
          <b-input v-model="group_name" disabled expanded></b-input>
        </b-field>

        <b-field horizontal :label="$t('attributes.group_code')">
          <b-input v-model="group_code" disabled expanded></b-input>
        </b-field>

        <form-group horizontal name="show" :label="$t('attributes.display')">
          <b-select v-model="form.show" name="show">
            <option value="true">{{ $t('attributes.yes') }}</option>
            <option value="false">{{ $t('attributes.no') }}</option>
          </b-select>
        </form-group>

        <form-group
          horizontal
          name="description"
          :label="$t('attributes.description')"
        >
          <b-input
            v-model="form.description"
            name="description"
            maxlength="112"
            :placeholder="
              $t('message.please_input') + $t('attributes.description')
            "
            expanded
          ></b-input>
        </form-group>

        <b-field horizontal grouped>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            :style="{ width: '100%' }"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>
  </section>
</template>

<script>
import { maxLength, required, requiredIf } from 'vuelidate/lib/validators'
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'AreaRecommend',

  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,

      group_code: this.travelGroup.code,
      group_name: this.travelGroup.name,

      form: this.extractFormValues(this.travelGroup)
    }
  },
  validations: {
    form: {
      show: { required },
      description: {
        requiredIf: requiredIf(function(model) {
          return model.show === 'true'
        }),
        maxLength: maxLength(112)
      }
    }
  },
  watch: {
    travelGroup(newGroup) {
      this.group_code = newGroup.code
      this.group_name = newGroup.name
      this.form = this.extractFormValues(newGroup)
    },
    'form.show'() {
      this.$v.$reset()
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        show: data.hot_flag === 'Y',
        description: data.hot_description
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${TRAVEL_GROUPS_API}/${this.group_code}/area-recommend`

      try {
        this.sending = true
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
